import React, { useState } from "react";
import { FaBuilding } from "react-icons/fa";
import { BsFillBuildingsFill } from "react-icons/bs";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";


function PgHstlFilter({ onGenderChange }) {

  useEffect(() => {
        AOS.init({
          duration: 1000, // Duration of the animation
          easing: "ease-in-out",
          once: false,
           // Animation triggers only once
        });
      }, []);


  const [activeButton, setActiveButton] = useState(1);
  const [gender, setGender] = useState(""); // State for gender

  const handleGenderChange = (event) => {
    const selectedGender = event.target.value;
    setGender(selectedGender); // Update the gender state
    onGenderChange(selectedGender); // Pass the selected gender to the parent
  };

  return (
    <div className="pb-10 px-4 lg:px-11 lg:pt-8 sm:pt-12 pt-5 flex flex-col md:flex-row flex-wrap justify-start items-center gap-4" >
      {/* Buttons Section */}
      <div className="flex justify-between items-center gap-4 border-[1px] border-gray-400 rounded-3xl w-full md:w-[40%] md:flex-row lg:flex-row" >
        {/* Hostel Button */}
        <button
          onClick={() => setActiveButton(1)} // Set active button to 1
          className={`flex justify-center items-center gap-2 w-full md:w-[60%] md:h-[40px] h-[30px] rounded-3xl text-[14px]  lg:text-lg md:text-md ${
            activeButton === 1
              ? "bg-gradient-to-r from-blue-500 to-[#01C3C7] text-white"
              : "bg-transparent text-gray-600"
          }`}
          id="btn"
          >
          <FaBuilding />
          PG/Hostel
        </button>

        {/* Flats Button */}
        <button
          onClick={() => setActiveButton(2)} // Set active button to 2
          className={`flex justify-center items-center gap-2 text-[14px]  lg:text-lg md:text-md text-center px-2 w-full md:w-[60%] md:h-[40px] h-[30px] rounded-3xl ${
            activeButton === 2
              ? "bg-gradient-to-r from-blue-500 to-[#01C3C7] text-white"
              : "bg-transparent text-gray-600"
          }`}
          id="btn1"
          
        >
          <BsFillBuildingsFill />
          Flats
        </button>
      </div>

      {/* Gender Dropdown */}
      <div className="w-full md:w-auto">
        <select
          value={gender} // Bind the select value to the gender state
          onChange={handleGenderChange} // Update the gender onChange
          name=""
          id="select1"
          className="w-full md:w-[170px] md:h-[40px] h-[30px] border-[1px] border-gray-400 text-[14px]  lg:text-lg md:text-md text-gray-700 rounded-3xl text-center"
          
        >
          <option value="" disabled>
            Gender
          </option>
          <option value="Men's PG">Men's PG</option>
          <option value="Women's PG">Women's PG</option>
          <option value="Not to say">Not to say</option>
        </select>
      </div>

      {/* Locality Dropdown */}
      <div className="w-full md:w-auto">
        <select
          name=""
          id="select2"
          className="w-full md:w-[170px] md:h-[40px] h-[30px] border-[1px] border-gray-400 text-[14px]  lg:text-lg md:text-md text-gray-700 rounded-3xl text-center"
          >
          <option value="" disabled selected>
            Locality
          </option>
          <option value="DownTown">DownTown</option>
          <option value="MidTown">MidTown</option>
          <option value="UpTown">UpTown</option>
          <option value="Other">Other</option>
        </select>
      </div>
    </div>
  );
}

export default PgHstlFilter;
